module.exports = __webpack_public_path__ + "img/avatar1.34b11a6d.png";